import DICTIONARY from "../constants/builds.constants";

export class BuildsPageController {
    constructor($scope, $stateParams, BuildsDao, User, ArtifactoryFeatures, $state, $filter, JFrogEventBus,
            DistributionDao, JFrogModal) {
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.JFrogEventBus = JFrogEventBus;
        this.$filter = $filter;
        this.distributionDao = DistributionDao;
        this.modal = JFrogModal;

        this.buildsDao = BuildsDao;
        this.DICTIONARY = DICTIONARY.tabs;

        this.buildTitle = this.$stateParams.buildName;

        this.user = User.getCurrent();
        this.features = ArtifactoryFeatures;
        this.userCanDistribute = false;

        this.tabs = [
            {name: 'published'},
            {name: 'environment'},
            {name: 'issues'},
            {name: 'licenses', feature: 'licenses'},
            {name: 'diff', feature: 'diff'},
            {name: 'history'},
            {name: 'json'}
        ];
        this.tabs.forEach((tab) => {
            tab.isDisabled = this._isTabDisabled(tab);
        });

        this._getBuildsData();

    }

    _isTabDisabled(tab) {
        return !this.user.canViewBuildState('builds.build_page', {tab: tab.name})
                || this.features.isDisabled(tab.feature);
    }

    // Get list of builds
    _getBuildsData() {
        this.buildsDao.getData({
            action: 'history',
            name: this.$stateParams.buildName
        })
        .$promise.then((data) => {
            this.builds = _.sortBy(data.pagingData, (i) => i.time);
            this.ciUrl = _.find(this.builds, {buildNumber: this.$stateParams.buildNumber}).ciUrl;
            this._getBuildData();
        });
    }

    _getBuildData() {
        this.buildsDao.getData({
            name: this.$stateParams.buildName,
            number: this.$stateParams.buildNumber,
            time: this.$stateParams.startTime,
            action:'buildInfo'
        }).$promise.then((data) => {
            this.userCanDistribute = data.userCanDistribute;
            this.$stateParams.startTime = data.time;
            this.buildData = data;
            this.summaryData = this.getSummaryColumns();
        });
    }

    getSummaryColumns() {
        let agentTemplate = (this.ciUrl) ? `<a class="jf-link" ng-href="{{BuildsPage.ciUrl}}" target="_blank">{{BuildsPage.buildData.agent}}</a>` : `{{BuildsPage.buildData.agent}}`;
        return [
            {
                label: 'Agent',
                template: agentTemplate,
                isActive: true
            },
            {
                label: 'Build Agent',
                template: '{{BuildsPage.buildData.buildAgent}}',
                isActive: true
            },
            {
                label: 'URL',
                template: '<a href="{{BuildsPage.buildData.url}}" target="_blank" class="jf-link" jf-tooltip-on-overflow>{{BuildsPage.buildData.url}}</a>',
                isActive: !!this.buildData.url
            },
            {
                label: 'Started',
                template: '<div class="text-truncate" jf-tooltip-on-overflow>{{BuildsPage.buildData.lastBuildTime | date:"d MMMM, yyyy"}} {{BuildsPage.buildData.lastBuildTime | date:"HH:mm:ss"}}</div>',
                isActive: true
            },
            {
                label: 'Duration',
                template: `{{BuildsPage.buildData.duration || '-'}}`,
                isActive: true
            },
            {
                label: 'Principal',
                template: `{{BuildsPage.buildData.principal || '-'}}`,
                isActive: true
            },
            {
                label: 'Artifactory Principal',
                template: `{{BuildsPage.buildData.artifactoryPrincipal || '-'}}`,
                isActive: true,
                width: '1.2fr'
            }
        ]
    }

    gotoVersion(build) {
        this.ciUrl = build.ciUrl;
        _.extend(this.$stateParams, {buildNumber: build.buildNumber,startTime: build.time, tab: this.$state.params.tab, moduleID: null});
        this.$state.go('.', this.$stateParams, { location: true, inherit: true, relative: this.$state.$current, notify: false, reload: true })
                .then(() => {
                    this._getBuildData();
                    this.JFrogEventBus.dispatch(this.JFrogEventBus.getEventsDefinition().BUILDS_TAB_REFRESH)
                })
    }



    distribute() {
        this.distributionDao.getAvailableDistributionRepos({}).$promise.then((data)=>{
            let modalInstance;
            this.distributeModalScope = this.$scope.$new();

            this.distributeModalScope.title = "Distribute " + this.$stateParams.buildName + " #" + this.$stateParams.buildNumber;
            this.distributeModalScope.distributionRepositoriesOptions = _.map(data.data.availableDistributionRepos, 'repoKey');

            this.distributeModalScope.data = {};
            this.distributeModalScope.data.async = true;
            this.distributeModalScope.data.publish = true;
            this.distributeModalScope.data.publish = true;
            this.distributeModalScope.data.overrideExistingFiles = false;
            this.distributeModalScope.data.selectedRepo = null;
            this.distributeModalScope.distType = "build";
            this.distributeModalScope.distribute = () => {
                this._resetChanges();
                this.distributionDao.distributeBuild({
                    targetRepo: this.distributeModalScope.data.selectedRepo,
                    async: this.distributeModalScope.data.async,
                    overrideExistingFiles: this.distributeModalScope.data.overrideExistingFiles,
                    date: this.$stateParams.startTime
                },{
                    buildName: this.$stateParams.buildName,
                    buildNumber: this.$stateParams.buildNumber,
                    date: this.$stateParams.startTime
                }).$promise.then((res)=>{
                    // Success
                    if (this.distributeModalScope.data.async) {
                        modalInstance.close();
                    } else {
                        this._runRulesTest(res);
                    }
                });
            };

            // DRY RUN
            this.distributeModalScope.dryRun = () => {
                this._resetChanges();
                this.distributionDao.distributeBuild({
                            targetRepo: this.distributeModalScope.data.selectedRepo,
                            async: this.distributeModalScope.data.async,
                            publish: this.distributeModalScope.data.publish,
                            overrideExistingFiles: this.distributeModalScope.data.overrideExistingFiles,
                            dryRun: true
                        }, {
                            buildName: this.$stateParams.buildName,
                            buildNumber: this.$stateParams.buildNumber,
                            date: this.$stateParams.startTime
                        }
                ).$promise.then((res)=>{
                    this._runRulesTest(res);
                });
            };

            modalInstance = this.modal.launchModal('distribute_modal', this.distributeModalScope, 650);
        });
    }

    _runRulesTest(res) {
        let ind = 0;
        let result = res.data;
        _.forEach(result, (value,key) => {
            if (key == 'distributed') {
                let distributed = result[key];

                _.forEach(distributed, (value,key) => {
                    distributed[key].customId = "dis" + ind;
                    ind++;

                    let packages = distributed[key].packages;

                    _.forEach(packages, (value,key) => {
                        packages[key].customId = "pac" + ind;
                        ind++;

                        let versions = packages[key].versions;
                        _.forEach(versions, (value,key) => {
                            versions[key].customId = "ver" + ind;
                            ind++;
                        });

                    });
                });
            }
        });
        this.distributeModalScope.data.dryRunResults = result;

        _.forEach(result.messagesByPath, (value) => {
            if (value.warnings) {
                this.distributeModalScope.data.warningExist = value.warnings.length ? true : false;
            }
            if (value.errors) {
                this.distributeModalScope.data.errorsExist = value.errors.length ? true : false;
            }
        });

        this._expandModal();
    }

    _expandModal(){
        $('form[name="distributeRepo"]')
                .closest('.modal-dialog')
                .animate({
                    maxWidth:'850px'
                },500);
    }
    _resetChanges() {
        // RESET
        this.distributeModalScope.data.dryRunResults = null;
        this.distributeModalScope.data.toggleSuccessTitle = null;
        this.distributeModalScope.data.toggleWarnTitle = null;
        this.distributeModalScope.data.toggleErrorTitle = null;
        this.distributeModalScope.data.warningExist = null;
        this.distributeModalScope.data.errorsExist = null;
    }

	backToBuilds() {
        this.$state.go('builds.all');
    }
}


// WEBPACK FOOTER //
// ./states/builds/builds_page/builds_page.controller.js